module.exports = __webpack_public_path__ + "media/images/booked-fb0f0abb0f542a2730b394881346ad21.png";